'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = validationErrors;

var _flat = require('flat');

var _flat2 = _interopRequireDefault(_flat);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a flat array of error objects suitable for
 * `react-forms` externalErrorList parameter, from a deep
 * nested object that matches CakePHP 3 validation errors.
 * 
 * @param   {Object}  errors
 * @returns {Array}
 */
function validationErrors(errors) {
  return (0, _map2.default)((0, _flat2.default)(errors), function (val, key) {
    return {
      field: 'data.' + key.replace(/[.^][^.]+$/, ''),
      message: val
    };
  });
}